import { Component, OnInit} from '@angular/core';


@Component({
  selector: 'app-guru-purnima',
  templateUrl: './guru-purnima.component.html',
  styleUrls: ['./guru-purnima.component.scss']
})
export class GuruPurnimaComponent implements OnInit{

  constructor() { }

  ngOnInit(): void {
  }

}
